/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-var-requires */
/* eslint-disable no-alert */
import axios from 'axios'
import {
  PatchMaintenace,
  DegradedDemand,
  EnableMaintenace,
  MaintenanceEntity,
  PatchAutomaticMode,
} from 'utils/__interfaces/SuperAdministration/Maintenance'

export const checkMaintenances = async (
  type?: string
): Promise<MaintenanceEntity[]> => {
  let maintenance = []
  try {
    const url = `${process.env.REACT_APP_BASE_API_URL}/check_maintenance`
    const params = new URLSearchParams()
    if (type) {
      params.append(`type`, type)
    }
    const resp = await axios({
      method: 'GET',
      url,
      params,
    })
    maintenance = resp?.data
  } catch (e) {
    // I want application to not crush, but don't care about the message
  }
  return maintenance
}

export async function checkAccessHP() {
  const passwordHP = `${process.env.REACT_APP_PASSWORD_HP}`
  const isAuth =
    localStorage.getItem('basic_auth') &&
    localStorage.getItem('basic_auth') === btoa(passwordHP)
  if (!isAuth) {
    let password: string | null = ''
    let success = false
    do {
      password = prompt('Entrez votre mot de passe :')
      if (password && password === passwordHP) {
        localStorage.setItem('basic_auth', btoa(password))
        success = true
      }
    } while (password === null || password === '' || !success)
  }
}

export async function updateMaintenance(data: PatchMaintenace): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/maintenance`

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })

    return resp
  } catch (err) {
    throw new Error(err as string)
  }
}

export async function enableMaintenance(data: EnableMaintenace): Promise<any> {
  const url = `${process.env.REACT_APP_BASE_API_URL}/maintenance/apply`

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
      headers: {
        'Content-Type': 'application/merge-patch+json',
        Authorization: axios.defaults.headers?.common?.Authorization || '',
      },
    })

    return resp
  } catch (err) {
    throw new Error(err as string)
  }
}

export const updateAutomaticMode = async (data: PatchAutomaticMode) => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/maintenance/edit_automatic_mode`

  try {
    const resp = await axios({
      method: 'PATCH',
      url,
      data,
    })

    return resp
  } catch (err) {
    throw new Error(err as string)
  }
}

export const submitDegradedDemand = async (
  data: DegradedDemand,
  turnstileToken?: string | null
): Promise<number> => {
  const url = `${process.env.REACT_APP_BASE_API_URL}/degraded_demand`
  const payload = { ...data, turnstileToken }
  try {
    const resp = await axios({
      method: 'POST',
      url,
      data: payload,
    })
    return resp?.status ?? 400
  } catch (err) {
    throw new Error(err as string)
  }
}
